import Vue from 'vue';
import VueSmoothScroll from 'vue2-smooth-scroll';
import VTooltip from 'v-tooltip';
import App from './App.vue';
import store from './store';
import router from './router';
import axios from 'axios';

Vue.use(VueSmoothScroll);
Vue.use(VTooltip, {
  defaultTemplate: '<div class="v-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
});

axios.defaults.withCredentials = true;
axios.defaults.baseURL = CONFIG.get('BASE_URL');
// axios.interceptors.response.use(undefined, function (error) {
//   console.log(error);
//   if (error) {
//     const originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       // store.dispatch('auth/logout');
//       // return router.push('/login')
//     }
//   }
// })

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});
